export default class Mask {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return '*** ****';
    }

    birthdate() {
        return '39-19-2999';
    }
}
